import config from "../../config";

const apiSlcEndpoint = config.apiSpiderLinksCheckerEndpoint;

export default apiSlcEndpoint;
